import { Component, Injector } from '@angular/core';
import * as moment from '@node_modules/moment-timezone';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';

@Component({
  selector: 'data-nascimento-form-cadastro-paciente',
  templateUrl: './data-nascimento-form-cadastro-paciente.component.html',
  styleUrls: ['./data-nascimento-form-cadastro-paciente.component.scss']
})
export class DataNascimentoFormCadastroPacienteComponent extends AppComponentBase {
  protected dia: number;
  protected mes: number;
  protected ano: number;
  private data: moment.Moment;

  constructor(injector: Injector) {
    super(injector)
  }

  public getData(): moment.Moment {
    this.data = moment({
      year: this.ano,
      month: this.mes - 1,
      date: this.dia
    });
    return this.data;
  }

  public ehMaiorIdade(): boolean {
    const hoje = moment();
    const idade = hoje.diff(this.data, 'years');

    return idade >= 18;
  }

  public isValided(): boolean {
    this.data = moment({
      year: this.ano,
      month: this.mes - 1,
      date: this.dia
    });

    const hoje = moment();
    const idade = hoje.diff(this.data, 'years');

    return this.showErros([
      { condition: StringUtils.isNullOrEmpty(this.data), message: "Informe a data!" },
      { condition: !this.data.isValid(), message: "Data de nascimento inválida!" },
      { condition: this.data.isAfter(hoje), message: "A data de nascimento não pode ser maior que a data atual!" },
      { condition: idade > 130, message: "A data de nascimento não pode indicar idade maior que 130 anos!" },
    ]);
  }

  private showErros(validations) {
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
